
<script setup>

  import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view">

      <div class="p-6">

        <div class="max-w-md">

          <h2 class="pb-6 border-b-[3px] border-black">

            <div class="text-xl tracking-narrow font-semibold uppercase">Activity 1</div>

            <div class="text-4xl md:text-5xl font-heading uppercase">Completed!</div>

          </h2>

          <p class="mt-8 leading-7 text-neutral-700">

            You have completed Activity 1: Hearing All the Stories.

            You can continue to Activity 2: Jim Crow Era Traveling, or

            return Home to choose another activity.

          </p>

        </div>

        <div class="flex flex-wrap justify-between gap-6 mt-12">

          <RouterLink

            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-neutral-600 transition-colors
                
              hover:bg-neutral-700 focus-visible:bg-neutral-700 hover:underline focus-visible:underline"
          
            to="/activities">
            
            <ArrowLeftCircleIcon class="w-8" />

            <span>Home</span>
          
          </RouterLink>

          <RouterLink

            class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-green-700 transition-colors
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
          
            to="/activity/2">
            
            <span>Next Activity</span>

            <ArrowRightCircleIcon class="w-8" />
          
          </RouterLink>

        </div>

      </div>

    </div>

  </article>

</template>
